var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.value)?_c('vx-lazy',[(_vm.editMode)?_c('vx-cell-permissions-checkbox-inner',{attrs:{"permissions-id":_vm.data.value.id}}):_c('vx-cell-permissions-icon-status',{attrs:{"permissions-id":_vm.data.value.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }